import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4g82895nb: FaireProductEntity = {
  token: "p_v4g82895nb",
  type: "product",
  name: "VITA Kuromi Grape Drink 220ml (Korea)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/9c8529729359353a5d61ce5c6149d64d5a8bd26a2316e9a445d6f2fef692cb2b.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.67,
  description:
    "VITA Kuromi Drink Grape from South Korea is a charming beverage presented in a 220 ml size bottle featuring a unique Kuromi character lid. This grape-flavored drink offers a delightful blend of sweetness and fruity tanginess, perfect for a refreshing treat. The Kuromi character lid adds a playful and collectible element to the packaging, making it appealing to fans of Sanrio characters and anyone looking to enjoy a fun and flavorful drink from South Korea. \n\n",
  tags: [],
  msrpDollars: 6.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:25.487Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
